import { FunctionComponent, memo } from 'react';
import { Toggle } from '@fluentui/react';
import { DynamicProps } from './DynamicProps';
import { getTranslationKey } from '../../../../Locales/i18n/utils';
import { translate, useTranslation } from '../../../../Locales/i18n/localizationService';

interface IProps extends DynamicProps<boolean, boolean> {
    OnText: string;
    OffText: string;
}

const DynamicToggle: FunctionComponent<IProps> = props => {
    const { t } = useTranslation();
    return (
        <Toggle
            onText={translate.exists(props.OnText) ? t(getTranslationKey(props.OnText)) : t('Common.Enable')}
            offText={translate.exists(props.OffText) ? t(getTranslationKey(props.OffText)) : t('Common.Disabled')}
            key={props.Key}
            onChange={(obj, value) => props.OnChange(props.PropertyInfo.PropertyName, value)}
            defaultChecked={props.Value}
            disabled={props.ReadOnly}
        />
    );
};

const comparisonFn = (prevProps: IProps, nextProps: IProps) => {
    return prevProps.Value === nextProps.Value;
};

export default memo(DynamicToggle, comparisonFn);
